/** Dictionary data type */
export class DictionaryType<T> {
  private items: { [index: string]: T } = {};
  private itemCount = 0;

  public constructor(public source?: Array<{ key: string, value: T }>) {
    if (source) {
      for (const keyValuePair of source) {
        this.add(keyValuePair.key, keyValuePair.value);
      }
    }
  }

  public containsKey(key: string): boolean {
    return this.items.hasOwnProperty(key);
  }

  public count(): number {
    return this.itemCount;
  }

  public add(key: string, value: T) {
    this.items[key] = value;
    this.itemCount++;
  }

  public set(key: string, value: T) {
    if (!this.containsKey(key)) {
      this.itemCount++;
    }
    this.items[key] = value;
  }

  public remove(key: string): T {
    const val = this.items[key];
    if (val) {
      delete this.items[key];
      this.itemCount--;
    }
    return val;
  }

  public removeAll(): void {
    this.items = {};
    this.itemCount = 0;
  }

  public copy(dictionary: DictionaryType<T>): void {
    this.removeAll();
    dictionary.keys().forEach(element => {
      const value = dictionary.item(element);
      this.add(element, value);
    });
  }

  public item(key: string): T {
    return this.items[key];
  }

  public keys(): string[] {
    const keySet: string[] = [];

    for (const prop in this.items) {
      if (this.items.hasOwnProperty(prop)) {
        keySet.push(prop);
      }
    }
    return keySet;
  }

  public values(): T[] {
    const values: T[] = [];

    for (const prop in this.items) {
      if (this.items.hasOwnProperty(prop)) {
        values.push(this.items[prop]);
      }
    }

    return values;
  }
}
